module.exports = "/_next/static/images/kit-phone-velieve@2x-min-ee61e7ae0a90f03bf08da924530a4d4b.png.webp";